// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__7hcNZ","animatedBlock":"Block_animatedBlock__U9P_C","fade":"Block_fade__17zOM","icon":"Block_icon__kpA62","text":"Block_text__ZJ7FY"};